import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Modal as DesignSystemModal } from '@domain-group/fe-co-allhomes-design-system';
import Loader from '@domain-group/fe-co-loader';
import * as styles from './modal.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Modal = _ref => {
  var title = _ref.title,
    buttonText = _ref.buttonText,
    children = _ref.children,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    error = _ref.error,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$submitEvent = _ref.submitEvent,
    submitEvent = _ref$submitEvent === void 0 ? {
      name: 'mfp-modal-submit'
    } : _ref$submitEvent,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? () => {} : _ref$onClose,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? () => {} : _ref$onSubmit;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleSubmit = () => {
    sendEvent(submitEvent.name, submitEvent.data);
    onSubmit();
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(DesignSystemModal, {
    show: show,
    title: title,
    onClose: onClose,
    fitContent: true,
    appearance: {
      desktop: 'floating',
      tablet: 'floating',
      mobile: 'auto'
    },
    footer: buttonText && ___EmotionJSX("div", {
      css: styles.modalFooter
    }, error ? ___EmotionJSX(Button, {
      stretched: true,
      onClick: onClose
    }, "Close") : ___EmotionJSX(Button, {
      stretched: true,
      onClick: handleSubmit
    }, buttonText))
  }, ___EmotionJSX("div", {
    css: styles.modalBody
  }, error ? ___EmotionJSX("p", null, error) : ___EmotionJSX(React.Fragment, null, children))), loading && ___EmotionJSX(Loader, {
    fullscreen: true
  }));
};
export default Modal;